import React from "react";
import reverraLogo from "../assets/Transparent_Logo.png";
import vtLogo from "../assets/vt_logo.png"; // Make sure this image is in src/assets

export default function Header() {
  return (
    <header className="bg-[#234C2C] h-25 flex justify-center items-center shadow-md">
      <div className="flex items-center space-x-6">
        <img src={reverraLogo} alt="Reverra Logo" className="h-32 object-contain" />
        <span className="text-[#F6F8D0] text-2xl font-bold">X</span>
        <img src={vtLogo} alt="VT Logo" className="h-32 object-contain" />
      </div>
    </header>
  );
}
